import { render } from "./ClockVue.vue?vue&type=template&id=d8f2b31a"
import script from "./ClockVue.vue?vue&type=script&lang=js"
export * from "./ClockVue.vue?vue&type=script&lang=js"

import "./ClockVue.vue?vue&type=style&index=0&id=d8f2b31a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__